import { render, staticRenderFns } from "./StatsBlob.vue?vue&type=template&id=9c43c1ae&"
import script from "./StatsBlob.vue?vue&type=script&lang=js&"
export * from "./StatsBlob.vue?vue&type=script&lang=js&"
import style0 from "./StatsBlob.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports